import { Injectable } from '@angular/core';
import { DataTableConfig } from 'src/shared/models/pagination.model';

@Injectable({
  providedIn: 'root',
})
export class CommonHelper {

  composeQuery(dataTableConfig: DataTableConfig) {
    let urlQuery = `pageIndex=${dataTableConfig.paginationConfig.pageIndex}&pageSize=${dataTableConfig.paginationConfig.pageSize}`;

    if (dataTableConfig.searchString) {
      urlQuery += `&searchString=${encodeURIComponent(
        dataTableConfig.searchString
      )}`;
    }
    else
    {
      urlQuery += `&searchString=`;
    }

    urlQuery += `&sortOrder=${
      dataTableConfig.sortOrder || 'asc'
    }&sortProperty=${dataTableConfig.sortProperty}`;

    return urlQuery;
  }

  /**
   * Updates the agent mode setting in localStorage and notifies other components
   * @param isAgentModeEnabled - The new agent mode state
   */
  updateAgentMode(isAgentModeEnabled: boolean): void {
    localStorage.setItem('isAgentModeEnabled', JSON.stringify(isAgentModeEnabled));
    // Dispatch custom event to notify other components of the change
    window.dispatchEvent(new CustomEvent('agentModeChanged', { 
      detail: { isAgentModeEnabled } 
    }));
  }

  /**
   * Gets the current agent mode setting from localStorage
   * @returns The current agent mode state
   */
  getAgentMode(): boolean {
    try {
      const storedValue = localStorage.getItem('isAgentModeEnabled');
      return storedValue ? JSON.parse(storedValue) : false;
    } catch (error) {
      console.error('Error reading isAgentModeEnabled from localStorage:', error);
      return false;
    }
  }
}
